import { render, staticRenderFns } from "./UpdateProjectModuleVisea.vue?vue&type=template&id=6d21b783&"
import script from "./UpdateProjectModuleVisea.vue?vue&type=script&lang=js&"
export * from "./UpdateProjectModuleVisea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports